import React, { useEffect, useState } from "react";
import "./header.scss";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import myLogo from "../../utils/img/Mylogo.png";
const NavHeader = ({ activeSection }) => {
  const navigate = useNavigate();
  const navigating = (e, to) => {
    e.preventDefault();
    navigate(to);
  };

  return (
    <header>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Container>
          <Navbar.Brand onClick={(e) => navigating(e, "/#intro")}>
            ELASHRY
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                onClick={(e) => navigating(e, "/#portfolio")}
                active={activeSection === "portfolio"}
              >
                Portfolio
              </Nav.Link>
              <Nav.Link
                onClick={(e) => navigating(e, "/#certifications")}
                active={activeSection === "certifications"}
              >
                Certifications
              </Nav.Link>
              <Nav.Link
                onClick={(e) => navigating(e, "/#skills")}
                active={activeSection === "skills"}
              >
                Skills
              </Nav.Link>

              <Nav.Link
                onClick={(e) => navigating(e, "/#contact")}
                active={activeSection === "contact"}
              >
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default NavHeader;
